import { render, staticRenderFns } from "./guides.vue?vue&type=template&id=45454c57&scoped=true"
import script from "./guides.vue?vue&type=script&lang=js"
export * from "./guides.vue?vue&type=script&lang=js"
import style0 from "./guides.vue?vue&type=style&index=0&id=45454c57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45454c57",
  null
  
)

export default component.exports